import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderTempTagDataSchema } from './ServicesProviderTempTagData.js';

class ServicesProviderTempTag extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderTempTagDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderTempTag.validation', `ServicesProviderTempTag data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.TEMP_TAG,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.TEMP_TAG, ServicesProviderTempTag);

export { ServicesProviderTempTag };
//# sourceMappingURL=ServicesProviderTempTag.js.map
